// extracted by mini-css-extract-plugin
module.exports = {"main":"Header_main__3EeGL","title":"Header_title__1101l"};